<div class="py-5 text-center">
  <h1>{{ title$ | async }}</h1>
  <h3>{{ message$ | async }}</h3>
</div>
